import React from 'react';

class CardPerson extends React.Component {

    emptyCard() {
        return (
            <div className="card-person__any">{this.props.item.title}</div>
        )
    }

    renderUserAvatar() {
        return <img className="card-person__image mx-auto" src={this.props.item.image} />
    }

    renderImagePlaceholder() {
        return <div className="card-person__default-image mx-auto"></div>
    }

    cardContent() {
        return (
            <div>
                { this.props.item.image ? this.renderUserAvatar() : this.renderImagePlaceholder() }
                
                <div className="card-person__name">{this.props.item.title}</div>
                <div className="card-person__role">{this.props.item.subtitle}</div>
            </div>
        )
    }

    render() {
        let cardClasses = 'card-person flex flex-col items-center justify-center';

        if (this.props.item.empty) {
            cardClasses += " any";
        }

        if (this.props.item.checked) {
            cardClasses += " checked";
        }

        return (
            <div className={cardClasses} onClick={this.props.changeHandler} >
                <div className="card-person__checked-icon"><i className="fas fa-check"></i></div>
                {
                    this.props.item.empty
                    ? this.emptyCard()
                    : this.cardContent()
                }
            </div>
        )
    }
}

export default CardPerson;


// WEBPACK FOOTER //
// ./scripts/components/CardPerson.jsx